import React from 'react';
import {connect} from "react-redux";
import Selectors from "../../selectors";
import {HEADER_MENU, LINKS, PAGES} from "../../constants";
import {updateCurrentPageAction} from "../../state/registration";

const stateToProps = (state) => ({
  isDesktop: Selectors.isDesktop(state),
  currentPage: Selectors.getCurrentPage(state),
});

const actionsToProps = (dispatch) => ({
  updateCurrentPage: (data) => dispatch(updateCurrentPageAction(data)),
});

const Header = (props) => {
  const links = LINKS;

  const goBackClick = () => {
    if (props.currentPage === PAGES.SECOND_STEP) {
      props.updateCurrentPage(PAGES.FIRST_STEP);
    }

    if (props.currentPage === PAGES.SMS_STEP) {
      props.updateCurrentPage(PAGES.SECOND_STEP);
    }
  };

  const headerMenuItems = HEADER_MENU;
  let menuItems = [];
  for(let item of headerMenuItems) {
    let tooltipHtml = '';
    if (item.tooltip) {
      tooltipHtml = <div className="h-ml__tooltip">{item.tooltip}</div>
    }

    menuItems.push(
      <li className="h-ml__nav-item" key={item.label}>
        <a className="h-ml__nav-link" href={item.url} title={item.label}>
          {item.label}
        </a>
        {tooltipHtml}
      </li>
    );
  }

  return (
    <header>

      {/* Mobile */}
      <div className="visible-s">
        <div className="h-s">
          <div className="h-s__wrap">
            <div className="h-s__wrap-item txt-l" >
              {!props.isDesktop && props.currentPage !== PAGES.FIRST_STEP && props.currentPage !== PAGES.COMPLETE_STEP && (
                  <div className="h-s__wrap-trigger px15 py10">
                    <i className="icon-back" onClick={() => {goBackClick();}} />
                    <span className="ml5 d-ib" onClick={() => {goBackClick();}}>Back</span>
                  </div>
              )}
            </div>
            <a href={links.home} title="Bet9ja" className="h-s__wrap-item logo">
              <i className="logo-s" />
            </a>
            <div className="h-s__wrap-item txt-r">
            </div>
          </div>
        </div>
      </div>

      {/* Desktop */}
      <div className="hidden-s">
        <div className="h-ml">
          <div className="container">
            <div className="h-ml__wrap">
              <div className="h-ml__logo" title="Bet9ja" onClick={() => window.open(links.home, '_self')}>
                <i className="h-ml__logo-icon" />
              </div>
              <div className="h-ml__nav">
                <ul className="h-ml__nav-list">
                  {menuItems}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

    </header>
  );
}

export default connect(
    stateToProps,
    actionsToProps
)(Header);
